import { Tooltip as ChakraTooltip } from '@chakra-ui/react'

export function Tooltip({ hasArrow = true, ...props }: React.ComponentProps<typeof ChakraTooltip>) {
  return <ChakraTooltip hasArrow={hasArrow} {...props} />
}
